export default __webpack_public_path__ + "static/media/microfone-start.8099d25d.png";